export default "__VITE_ASSET__Cw$mpBK$__"